function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "account");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.22,11.7A45,45,0,0,0,14.71,78.24c.66.59,1.33,1.17,2,1.73A45.06,45.06,0,0,0,45,89.92,44.49,44.49,0,0,0,73.18,80a45.48,45.48,0,0,0,5.06-4.76A45,45,0,0,0,75.22,11.7ZM75.64,69C73.24,59.08,60.42,51.5,45,51.5S16.69,59.08,14.3,69a39,39,0,1,1,61.34,0Z",
  fill: "#e3e3e3"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 44.97,
  cy: 30.3,
  r: 14.62,
  transform: "translate(-9.23 32.06) rotate(-35.83)",
  fill: "#e3e3e3"
});

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 89.94,
    height: 89.92,
    viewBox: "0 0 89.94 89.92",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.8677c9b3.svg";
export { ForwardRef as ReactComponent };